import { AsyncPipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgxSpinnerComponent, NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject, EMPTY } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { AuthService } from '../../core/auth/auth.service';
import { AutoUnsubscribe } from '../../core/auto-unsubscribe';

@AutoUnsubscribe()
@Component({
  selector: 'app-azure-callback',
  templateUrl: './azure-callback.component.html',
  styleUrls: ['./azure-callback.component.scss'],
  imports: [
    MatCard,
    MatCardContent,
    NgxSpinnerComponent,
    MatIcon,
    AsyncPipe,
    TranslateModule,
  ],
})
export class AzureCallbackComponent implements OnInit {
  subs = new SubSink();

  error$ = new BehaviorSubject<boolean>(false);

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private translateService: TranslateService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    _('ERROR.AZURE_AUTH_API.IDTOKEN_MISSING');
    _('ERROR.AZURE_AUTH_API.UPN_NOT_SET');
    _('ERROR.AZURE_AUTH_API.MULTIPLE_USERS_WITH_UPN');
    _('ERROR.AZURE_AUTH_API.TID_NOT_SET');
    _('ERROR.AZURE_AUTH_API.EMAIL_NOT_SET');
    _('ERROR.AZURE_AUTH_API.MULTIPLE_USERS_WITH_USERID_AND_TENANT');
    _('ERROR.AZURE_AUTH_API.MULTIPLE_SSOCONFIGS_FOR_TENANT');
    _('ERROR.AZURE_AUTH_API.JURPERSON_MISSING');
    _('ERROR.AZURE_AUTH_API.NO_SSOCONFIG_FOR_TENANT');
    _('ERROR.AZURE_AUTH_API.NATPERSON_CREATION_FAILED');
    _('ERROR.AZURE_AUTH_API.UNAVIALABLE');
    _('ERROR.AZURE_AUTH_API.USER_INACTIVE');
    _('ERROR.AZURE_AUTH_API.USER_NOT_APPROVED');
    _('ERROR.AZURE_AUTH_API.NATPERSON_ALREADY_EXISTS');

    this.subs.sink = this.route.queryParamMap
      .pipe(
        tap(() => this.spinner.show('azure-callback')),
        switchMap(() => this.authService.azureSignIn()),
        catchError((response: HttpErrorResponse) => {
          this.spinner.hide('azure-callback');
          this.error$.next(true);

          let message = response.error['message'];
          if (message == undefined) {
            message = 'UNAVIALABLE';
          }

          this.snackBar.open(
            this.translateService.instant('ERROR.AZURE_AUTH_API.' + message),
            this.translateService.instant('SHARED.OK')
          );

          return EMPTY;
        })
      )
      .subscribe(() => {
        let returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');

        if (returnUrl == null) {
          returnUrl = '/';
        }

        this.router.navigateByUrl(returnUrl);
      });
  }
}
